import { render, staticRenderFns } from "./CompanyConceptModal.vue?vue&type=template&id=830b75ac&scoped=true&"
import script from "./CompanyConceptModal.vue?vue&type=script&lang=js&"
export * from "./CompanyConceptModal.vue?vue&type=script&lang=js&"
import style0 from "./CompanyConceptModal.vue?vue&type=style&index=0&id=830b75ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830b75ac",
  null
  
)

export default component.exports